import React from 'react';
import { Box, FormControl, Select, Typography } from '@mui/material';
import { buildSelectFieldSx, fieldLabelRowSx } from './formFieldStyles';

const SalovareSelectField = ({
  label,
  required = false,
  error = false,
  helperText,
  children,
  fullWidth = true,
  sx,
  MenuProps,
  labelAdornment,
  ...selectProps
}) => {
  const mergedMenuProps = { disableScrollLock: true, ...MenuProps };

  return (
    <Box sx={{ minWidth: 0, width: fullWidth ? '100%' : undefined, ...sx }}>
      {label && (
        <Box sx={fieldLabelRowSx}>
          <Typography variant="subtitle2" sx={{ fontWeight: 600, lineHeight: 1.2 }}>
            {label}
            {required ? ' *' : ''}
          </Typography>
          {labelAdornment}
        </Box>
      )}
      <FormControl fullWidth={fullWidth} error={error} sx={{ minWidth: 0 }}>
        <Select
          {...selectProps}
          fullWidth={fullWidth}
          MenuProps={mergedMenuProps}
          sx={buildSelectFieldSx(error)}
        >
          {children}
        </Select>
      </FormControl>
      {helperText && (
        <Typography variant="caption" sx={{ color: '#f44336', mt: 0.5, display: 'block' }}>
          {helperText}
        </Typography>
      )}
    </Box>
  );
};

export default SalovareSelectField;
